module.exports = __webpack_public_path__ + "media/images/angle_doubleup-bf0b20dad02df475936958a38583caa4.svg";